"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iosArrowDown = void 0;
var iosArrowDown = {
  "viewBox": "0 0 512 512",
  "children": [{
    "name": "polygon",
    "attribs": {
      "points": "396.6,160 416,180.7 256,352 96,180.7 115.3,160 256,310.5 "
    },
    "children": []
  }]
};
exports.iosArrowDown = iosArrowDown;